import React from 'react'
import { connect } from 'react-redux'
import { doGetPersonAttachKind, doSavePersonAttachKind, doDeletePersonAttachKind } from '../../reducers/actions'

class PersonAttachKindDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { onClose, dispatch, id } = this.props
        dispatch(doGetPersonAttachKind({
            id,
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (initValues基本信息) {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        }))
    }

    handlerConfirm = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        const { onSave, onClose, dispatch } = this.props
        dispatch(doSavePersonAttachKind({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        }))
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose, dispatch } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeletePersonAttachKind({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            })))
    }


    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        return Object.keys(changedValues基本信息).length > 0 || id < 0
    }

    fieldset基本信息 = () => {
        return [
            { _text: '分类名称', minWidth: '95%', },
            { _number: '排序', minWidth: '95%', },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        return <Body data={this} maxWidth="600"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(PersonAttachKindDiv)